export function HeroSection() {
    return (
        <section className="relative overflow-hidden py-[5rem] md:py-[6rem]" aria-labelledby="hero-heading">
            <div className="absolute inset-0 bg-gradient-to-br from-[#E81932]/10 via-transparent to-[#E81932]/5" aria-hidden="true"></div>
            <div className="relative mx-auto mt-[5rem] max-w-7xl px-4 sm:px-6 lg:px-8">
                <div className="mx-auto max-w-4xl text-center">
                    <h1 id="hero-heading" className="mb-6 text-4xl leading-tight font-bold text-[#F8FAFC] sm:text-5xl md:text-6xl">
                        Turkish Airlines
                        <br />
                        <span className="bg-gradient-to-r from-[#E81932] to-[#C41E3A] bg-clip-text text-transparent">MCP Server</span>
                    </h1>
                    <p className="mx-auto mb-10 max-w-3xl text-lg leading-relaxed text-[#CBD5E1] md:text-xl">
                        Empower your AI assistants with real-time access to Turkish Airlines services. Search flights, manage bookings, and deliver personalized travel experiences.
                    </p>

                    <div className="mb-8 flex flex-col items-center justify-center gap-4 sm:flex-row">
                        <a
                            href="#getting-started"
                            className="inline-flex transform items-center gap-2 rounded-xl bg-gradient-to-r from-[#E81932] to-[#C41E3A] px-8 py-4 font-semibold text-white shadow-xl shadow-[#E81932]/20 transition-all hover:scale-105 hover:shadow-[#E81932]/30"
                            aria-label="Get started with MCP Server"
                        >
                            <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z"></path>
                            </svg>
                            Get Started
                        </a>
                        <a href="#tools" className="inline-flex items-center gap-2 rounded-xl border border-[#CBD5E1]/20 bg-[#363A42] px-8 py-4 font-semibold text-[#F8FAFC] transition-all hover:border-[#E81932]/50" aria-label="View available tools">
                            <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
                                ></path>
                            </svg>
                            View Tools
                        </a>
                    </div>

                    <div className="inline-flex items-center gap-2 rounded-lg border border-[#CBD5E1]/10 bg-[#363A42]/50 px-4 py-3" role="note">
                        <svg className="h-5 w-5 flex-shrink-0 text-[#CBD5E1]" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 3v2m6-2v2M9 19v2m6-2v2M5 9H3m2 6H3m18-6h-2m2 6h-2M7 19h10a2 2 0 002-2V7a2 2 0 00-2-2H7a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
                        </svg>
                        <p className="text-sm text-[#CBD5E1]">Compatible with ChatGPT, Claude, VS Code Copilot &amp; more</p>
                    </div>
                </div>
            </div>
        </section>
    );
}
